/** Whether Escape at `target` belongs to an open combobox popup rather than the dialog or sheet around it; a filter list's search is always "expanded" but inline, so it is not one. */
export function isEscapeForComboboxPopup(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest('[data-slot="filter-list-search"]') === null &&
    target.closest('[role="combobox"][aria-expanded="true"], [data-slot="combobox-content"]') !==
      null
  );
}
